import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";

export default function AuthCallbackPage() {
  const navigate = useNavigate();
  useEffect(() => {
    // detectSessionInUrl já processa o hash; basta aguardar e redirecionar
    supabase.auth.getSession().then(({ data }) => {
      navigate(data.session ? "/upload" : "/login", { replace: true });
    });
  }, [navigate]);
  return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Autenticando...</div>;
}
